import * as yup from 'yup';

export interface AppNotificationDto {
    id?: string;
    title: string;
    content: string;
}

export const appNotificationInit: AppNotificationDto = {
    id: '',
    title: '',
    content: ''
}

export const notificationValidationSchema = yup.object().shape({
    title: yup.string().max(50, "Title must be less than 50 characters").required("Please enter a title."),
    content: yup.string().max(150, "Title must be less than 150 characters").required("Please enter a message."),
});